<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
    <router-view v-if="isRouterAlive" />
    <!-- </transition> -->
  </div>
</template>
<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
      lastTime: new Date().getTime(),
      timeOut: 30 * 60 * 1000
    }
  },
  data() {
    return {
      transitionName: '',
      isRouterAlive: true
    }
  },
  watch: {
    // 使用watch 监听$router的变化
    $route(to, from) {
      // 如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        // 设置动画名称
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    }
  },
  created() {
    // // bind event
    // this.$navigation.on('forward', (to, from) => {
    // console.log('forward to', to, 'from ', from)
    // })
    // this.$navigation.on('back', (to, from) => {
    // console.log('back to', to, 'from ', from)
    // })
    // this.$navigation.on('replace', (to, from) => {
    // console.log('replace to', to, 'from ', from)
    // })
    // this.$navigation.on('refresh', (to, from) => {
    // console.log('refresh to', to, 'from ', from)
    // })
    // this.$navigation.on('reset', () => {
    // console.log('reset')
    // })
    // // and use [once, off] methods
    // this.$navigation.once('forward', () => {
    // console.log('appear once')
    // })
    // const off = () => {
    // console.log('will not appear')
    // }
    // this.$navigation.on('forward', off)
    // this.$navigation.off('forward', off)
  },
  mounted() {
    this.setLanguage()
  },
  methods: {
    setLanguage() {
      if (window.localStorage.getItem('language') === null || window.localStorage.getItem('language') === 'cn') {
        window.localStorage.setItem('language', 'cn')
        this.$i18n.locale = window.localStorage.getItem('language')
      } else if (window.localStorage.getItem('language') === 'en') {
        this.$i18n.locale = window.localStorage.getItem('language')
      }
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
    moveEvent: function() {
      if ((new Date().getTime() - this.lastTime) > this.timeOut) {
        if (this.$store.getters.token) {
          this.$store.dispatch('user/autoLogout').then(() => {
            this.$alert('超时未操作，请重新登录。', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              callback: action => {
                if (action === 'cancel' || action === 'confirm') {
                  this.$router.replace({
                    name: 'login',
                    query: { redirect: this.$router.history.current.fullPath }
                  })
                }
              }
            })
          })
        }
      }
      this.lastTime = new Date().getTime()
    }
  }
}
</script>
<style lang="scss">
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
// html {
//   overflow-y: scroll;
// }

// :root {
//   overflow-y: auto;
//   overflow-x: hidden;
// }

// :root body {
//   position: absolute;
// }

// body {
//   width: 100vw;
//   overflow: hidden;
// }
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
// .slide-fade {
//   position: fixed;
//   left: 0;
//   right: 0;
//   width: 100%;
//   background-color: white;
// }
// .slide-fade-enter,
// .slide-fade-leave-to {
//   left: 0;
//   top: 0;
//   right: 0;
//   position: absolute;
//   transform: translateX(-500px) translateY(0px) rotate(0deg) scale(1);
//   opacity: 1;
// }
// .slide-fade-enter-active {
//   background-color: white;
//   transition: all 0.6s ease;
// }
// .slide-fade-leave-active {
//   transition: all 0.7s ease;
//   background-color: white;
//   transform: translateX(500px) translateY(0px) rotate(0deg) scale(1);
//   z-index: 100;
// }
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-right-enter {
  background-color: white;
  opacity: 0;
  // transform: translate3d(-50%, 0, 0);
  transform: translateX(-500px) translateY(0px) rotate(0deg) scale(1);
}
.slide-right-leave-active {
  background-color: white;
  opacity: 0;
  // transform: translate3d(50%, 0, 0);
  transform: translateX(500px) translateY(0px) rotate(0deg) scale(1);
}
.slide-left-enter {
  background-color: white;
  opacity: 0;
  // transform: translate3d(50%, 0, 0);
  transform: translateX(500px) translateY(0px) rotate(0deg) scale(1);
}
.slide-left-leave-active {
  background-color: white;
  opacity: 0;
  // transform: translate3d(-50%, 0, 0);
  transform: translateX(-500px) translateY(0px) rotate(0deg) scale(1);
}
</style>
